export default {
  methods: {
    autoExpandTextarea(event) {
      /* Code from https://stackoverflow.com/questions/2803880/is-there-a-way-to-get-a-textarea-to-stretch-to-fit-its-content-without-using-php */
      let textArea = event.target;
      if (!textArea) return;

      textArea.style.height = ""; // Reset allows it to shrink
      textArea.style.height = textArea.scrollHeight + "px";
    },
  },
};
